module.exports = __webpack_public_path__ + "static/img/bg.d34e66b6.jpg";